import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { ILoadedProps, IProps } from './interfaces';

export const path = '/checklist/:id';
export const getPath = (id: string) => `/checklist/${id}`;

const PageChecklist: React.FC<IProps> = (props) => {
  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import(`./page`),
      i18n: () => import(`./ru.json`),
    },
    loading: LoadableLoading,
    render(loaded: ILoadedProps, loadedProps: {}) {
      const Page: any = loaded.page.default;

      return <Page {...loadedProps} {...props} i18n={{ ...loaded.i18n }} />;
    },
  });

  return <LoadableMap {...props} />;
};

export default PageChecklist;
